import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { CHF } from "@/lib/apiClient";

export const CartFooter = () => {
  const { cartCount, cartSubtotal } = useStore();
  const navigate = useNavigate();
  if (cartCount === 0) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-3 bg-black" data-testid="cart-footer">
      <button
        onClick={() => navigate("/checkout")}
        data-testid="view-cart-btn"
        className="w-full max-w-2xl mx-auto flex items-center justify-between bg-brand-red text-white px-5 h-14 font-semibold"
      >
        <span className="flex items-center gap-3">
          <span className="relative">
            <ShoppingBag className="w-5 h-5" />
            <span className="absolute -top-2 -right-2 bg-white text-brand-red text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold">{cartCount}</span>
          </span>
          Voir le panier
        </span>
        <span data-testid="cart-footer-total">{CHF(cartSubtotal)}</span>
      </button>
    </div>
  );
};
